import jump from 'jump.js'

export default linen => {
  const jumpLink = document.querySelector('.js-explore-linen')

  jumpLink.addEventListener('click', () => {
    jump('.linen-product-container', {
      offset: -75
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/linen.js